import { Box, type BoxProps } from "@chakra-ui/react";

function CardBody({ children }: BoxProps) {
	return (
		<Box px="20px" py="20px" style={{ wordBreak: "break-word" }}>
			{children}
		</Box>
	);
}

export default CardBody;
